import { ValveIcon } from "@eisox/icons";
import { validateValveMac } from "@eisox/valves";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { valveApi } from "~/api";
import { ReplaceMacDialog } from "~/components/replace-mac-dialog";
import { m } from "~/paraglide/messages";
import type { EnhancedValve } from "~/types/valve.type";

interface ReplaceValveDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  buildingId: string;
  valve: EnhancedValve;
  valves: EnhancedValve[];
}

export const ReplaceValveDialog: React.FC<ReplaceValveDialogProps> = ({
  open,
  onOpenChange,
  buildingId,
  valve,
  valves,
}) => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation({
    mutationFn: (mac: string) => valveApi.update(buildingId, [{ ids: [valve.id], mac }]),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: valveApi.queries.building(buildingId).queryKey }),
  });

  if (!valve.mac) return null;

  return (
    <ReplaceMacDialog
      open={open}
      onOpenChange={onOpenChange}
      title={m.replace_valve()}
      icon={<ValveIcon />}
      currentMac={valve.mac}
      existingMacs={valves.map(v => v.mac)}
      validateMac={validateValveMac}
      type="valve"
      onSubmit={mac => mutateAsync(mac)}
    />
  );
};
